export default {
  // Housekeeper Management Page
  'pages.housekeeper.title': 'Dedicated Housekeeper',
  'pages.housekeeper.subTitle': 'Manage dedicated housekeeper information in the community',
  'pages.housekeeper.breadcrumb.person': 'Personnel Management',
  'pages.housekeeper.breadcrumb.housekeeper': 'Dedicated Housekeeper',

  // Language Options
  'pages.housekeeper.lang.chinese': 'Chinese',
  'pages.housekeeper.lang.english': 'English',

  // Table Related
  'pages.housekeeper.table.title': 'Housekeeper List',
  'pages.housekeeper.table.headerTitle': 'Housekeeper List',
  'pages.housekeeper.table.button.add': 'Add Housekeeper',
  'pages.housekeeper.table.button.edit': 'Edit',
  'pages.housekeeper.table.button.view': 'View',
  'pages.housekeeper.table.button.enable': 'Enable',
  'pages.housekeeper.table.button.disable': 'Disable',

  // Table Column Titles
  'pages.housekeeper.table.columns.avatar': 'Avatar',
  'pages.housekeeper.table.columns.name': 'Name',
  'pages.housekeeper.table.columns.position': 'Position',
  'pages.housekeeper.table.columns.phone': 'Phone',
  'pages.housekeeper.table.columns.email': 'Email',
  'pages.housekeeper.table.columns.serviceTime': 'Service Time',
  'pages.housekeeper.table.columns.status': 'Status',
  'pages.housekeeper.table.columns.createdTime': 'Created Time',
  'pages.housekeeper.table.columns.operations': 'Operations',

  // Status Labels
  'pages.housekeeper.status.notServiced': 'Not Serviced',
  'pages.housekeeper.status.servicing': 'Servicing',
  'pages.housekeeper.status.disabled': 'Disabled',

  // Form Related
  'pages.housekeeper.form.title.edit': 'Edit Housekeeper',
  'pages.housekeeper.form.title.add': 'Add Housekeeper',
  'pages.housekeeper.form.label.name': 'Name',
  'pages.housekeeper.form.label.avatar': 'Avatar',
  'pages.housekeeper.form.label.position': 'Position',
  'pages.housekeeper.form.label.phone': 'Phone',
  'pages.housekeeper.form.label.email': 'Email',
  'pages.housekeeper.form.label.serviceTime': 'Service Time',
  'pages.housekeeper.form.label.status': 'Status',
  'pages.housekeeper.form.label.description': 'Description',

  // Form Placeholders
  'pages.housekeeper.form.placeholder.name': 'Please enter name',
  'pages.housekeeper.form.placeholder.position': 'Please enter position',
  'pages.housekeeper.form.placeholder.phone': 'Please enter phone number',
  'pages.housekeeper.form.placeholder.email': 'Please enter email',
  'pages.housekeeper.form.placeholder.serviceTime': 'Please enter service time',
  'pages.housekeeper.form.placeholder.status': 'Please select status',
  'pages.housekeeper.form.placeholder.description': 'Please enter description',

  // Form Validation
  'pages.housekeeper.form.validation.name.required': 'Please enter name',
  'pages.housekeeper.form.validation.status.required': 'Please select status',
  'pages.housekeeper.form.validation.email.pattern': 'Please enter a valid email format',

  // Status Options
  'pages.housekeeper.form.status.notServiced': 'Not Serviced',
  'pages.housekeeper.form.status.servicing': 'Servicing',
  'pages.housekeeper.form.status.disabled': 'Disabled',

  // Avatar Upload Related
  'pages.housekeeper.avatar.upload.tab.local': 'Local Upload',
  'pages.housekeeper.avatar.upload.tab.url': 'Avatar URL',
  'pages.housekeeper.avatar.upload.placeholder.url': 'Please enter avatar URL',
  'pages.housekeeper.avatar.upload.hint.drag': 'Drag or click to upload avatar',
  'pages.housekeeper.avatar.upload.hint.uploading': 'Uploading...',
  'pages.housekeeper.avatar.upload.hint.change': 'Click or drag image here to change',
  'pages.housekeeper.avatar.upload.hint.format': 'Support JPG/PNG/GIF/WEBP format, max 20MB',
  'pages.housekeeper.avatar.upload.hint.size': 'Recommended size: Square avatar, image will display as full URL but only store relative path to database',
  'pages.housekeeper.avatar.upload.error.type': 'Only image files can be uploaded!',
  'pages.housekeeper.avatar.upload.error.size': 'Image size cannot exceed 20MB!',
  'pages.housekeeper.avatar.upload.success': 'Avatar uploaded successfully',
  'pages.housekeeper.avatar.upload.error': 'Avatar upload failed',

  // Message Prompts
  'pages.housekeeper.message.disable.success': 'Disabled successfully',
  'pages.housekeeper.message.disable.error': 'Disable failed',
  'pages.housekeeper.message.enable.success': 'Enabled successfully',
  'pages.housekeeper.message.enable.error': 'Enable failed',
  'pages.housekeeper.message.detail.error': 'Failed to get details',
  'pages.housekeeper.message.update.success': 'Updated successfully',
  'pages.housekeeper.message.update.error': 'Update failed',
  'pages.housekeeper.message.create.success': 'Created successfully',
  'pages.housekeeper.message.create.error': 'Create failed',
  'pages.housekeeper.message.operation.error': 'Operation failed',

  // Confirmation Dialogs
  'pages.housekeeper.confirm.enable.title': 'Are you sure you want to enable this housekeeper?',
  'pages.housekeeper.confirm.enable.description': 'After enabling, the housekeeper will return to normal use',
  'pages.housekeeper.confirm.disable.title': 'Are you sure you want to disable this housekeeper?',
  'pages.housekeeper.confirm.disable.description': 'After disabling, the housekeeper will not be able to use normally',
  'pages.housekeeper.confirm.okText': 'OK',
  'pages.housekeeper.confirm.cancelText': 'Cancel',

  // Detail Modal
  'pages.housekeeper.detail.title': 'Housekeeper Details',
  'pages.housekeeper.detail.button.close': 'Close',
  'pages.housekeeper.detail.section.basic': 'Basic Information',
  'pages.housekeeper.detail.section.detail': 'Detailed Information',
  'pages.housekeeper.detail.label.position': 'Position',
  'pages.housekeeper.detail.label.serviceTime': 'Service Time',
  'pages.housekeeper.detail.label.phone': 'Phone',
  'pages.housekeeper.detail.label.email': 'Email',
  'pages.housekeeper.detail.label.description': 'Description',
  'pages.housekeeper.detail.label.createdTime': 'Created Time',
  'pages.housekeeper.detail.label.updatedTime': 'Updated Time',

  // Other Texts
  'pages.housekeeper.text.dash': '-',
};
